import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, first, map, timeout } from 'rxjs/operators';
import { of } from 'rxjs';
import { UrlService } from '../url.service';
import { environment } from "src/environments/environment";
import { LogRequest } from 'src/app/entities/shared/Logs/LogRequest';
import { LocalStorageService } from '../local-storage/local-storage.service';
import LOG_MOCK from 'src/assets/data/ar/log/LOG.json';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(
    private http: HttpClient,
    private urlService: UrlService,
    private localStorageService: LocalStorageService,
  ) { }

  saveLog(logRequest: LogRequest) {
    const currentCountry = this.localStorageService.getRegionSeleccionada?.getCode().toUpperCase();
    const username: string = this.localStorageService.dataLogin?.getUser();
    logRequest.country = currentCountry;
    logRequest.user = username;
    console.log("log service: ", JSON.stringify(logRequest));

    // cambio para ruta de Microservicios
    let msGCPInt = "/".concat(this.localStorageService.configInit["F_URL_MS_IM_GCP"]);
    let msGCPVip = "/gcp-service";
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? (!this.localStorageService.getIsVip ? msGCPInt : msGCPVip)
      : "";
    const backendUrl = this.urlService.getURL(rutaMicroservicio);

    const logURL = this.localStorageService.getIsVip ? "reg" : "log";
    const endpoint = `/v1/${logURL}`;

    const headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${backendUrl}${endpoint}`, JSON.stringify(logRequest), { headers: headers }).
      pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }

  getListMatchKey(selected: any[]) {
    let matchArray: string[] = [];
    selected.forEach(item => {
      if (item.hasOwnProperty('matchKey')) {
        matchArray.push(item.matchKey);
      }
    });
    let matchKeySelected = matchArray.map(matchKey => {
      return {
        field: 'matchKey',
        value: matchKey
      };
    });
    return matchKeySelected;
  }


  getLogs(body, pageSize, pageNumber) {
    if (environment.CONSUME_API_LOG.toString().toLowerCase() !== "true") {
      return of(LOG_MOCK);
    }

    const currentCountry = this.localStorageService.getRegionSeleccionada?.getCode().toUpperCase();
    let msGCPInt = "/".concat(this.localStorageService.configInit["F_URL_MS_IM_GCP"]);
    let msGCPVip = "/gcp-service";
    let rutaMicroservicio = environment.MICROSERVICIO.toString().toLowerCase() === "true"
      ? (!this.localStorageService.getIsVip ? msGCPInt : msGCPVip)
      : "";
    const backendUrl = this.urlService.getURL(rutaMicroservicio);

    const logURL = this.localStorageService.getIsVip ? "log" : "log";
    const endpoint = `/v1/${logURL}/byDate/${currentCountry}?pageSize=${pageSize}&pageNumber=${pageNumber}`;

    const headers = new HttpHeaders().append('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<any>(`${backendUrl}${endpoint}`, JSON.stringify(body), { headers: headers })
      .pipe(timeout(Number(environment.HTTP_REQUEST_TIMEOUT)));
  }
}
